import { clientConfig } from '@/rollbar';
import { NextRequest } from 'next/server';
import Rollbar from 'rollbar';

let clientRollbar: Rollbar | undefined;

function getClientRollbar() {
  clientRollbar ??= new Rollbar(clientConfig);
  return clientRollbar;
}

// Report an exception to Rollbar from browser code (uses the public client token).
export function reportError(
  error: Error | string,
  /* eslint-disable @typescript-eslint/no-explicit-any */
  additionalInfo: Record<string, any> = {}
  /* eslint-enable @typescript-eslint/no-explicit-any */
) {
  getClientRollbar().error(error, { ...additionalInfo });
}

// In Express, you can pass req/res directly to Rollbar for automatic metadata extraction.
// With Next.js’ NextRequest and Response, that doesn’t work. These helpers manually
// extract and format key fields so Rollbar can record request and response details properly.
export function responseToRollbarObject(res: Response) {
  return {
    headers: res.headers,
    status: res.status,
    url: res.url,
  };
}

export function requestToRollbarObject(req: NextRequest) {
  return {
    headers: req.headers,
    method: req.method,
    url: req.url,
    body: req.body,
  };
}
